<template lang="html">
  <div
    class="wm_resizer"
    @mousedown="start_drag($event)"
    @mouseup="is_dragging = false"
  ></div>
</template>

<script>
export default {
  emits: ['update:modelValue'],
  // eslint-disable-next-line
  name: "Resizer",
  data() {
    return {
      is_dragging: false,
      // Distance from the pointer to the panel edge at the moment of grabbing
      drag_offset: 0
    };
  },

  props: {
    modelValue: {
      type: Number,
      default: 100
    },

    min: {
      type: Number,
      default: 100
    },

    max: {
      type: Number,
      default: 200
    }
  },

  methods: {
    start_drag(event) {
      this.is_dragging = true;
      this.drag_offset = event.clientX - this.modelValue;
    },
    on_dragging(event) {
      if (this.is_dragging) {
        if (this.$app.ui.mousedown) {
          let width = event.clientX - this.drag_offset;
          if (width > this.max) width = this.max;
          if (width < this.min) width = this.min;
          this.$emit("update:modelValue", width);
        } else {
          this.is_dragging = false;
        }
      }
    }
  },

  created() {
    window.addEventListener("mousemove", this.on_dragging);
  },

  unmounted() {
    window.removeEventListener("mousemove", this.on_dragging);
    document.body.classList.remove("wm_resizing");
  },

  watch: {
    is_dragging(active) {
      document.body.classList.toggle("wm_resizing", active);
    },
    "$app.ui.mousedown": function() {
      if (!this.$app.ui.mousedown) this.is_dragging = false;
    }
  }
};
</script>

<style lang="css" scoped></style>
